import { useParams } from "react-router-dom";
import Toast from "@/common/components/ui/toast";
import Dashboard from "@/common/components/layout/Dashboard";
import { LoanDashboard } from "./components/loan-dashboard";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import { LoanDashboardProvider } from "./components/loan-dashboard/LoanDashboard.provider";

function LoanDetailsPage() {
  const { loanId } = useParams();
  return (
    <ToastProvider>
      <Dashboard>
        <LoanDashboardProvider loanId={loanId || ''}>
          <LoanDashboard />
        </LoanDashboardProvider>
        <Toast />
      </Dashboard>
    </ToastProvider>
  )
}

export default LoanDetailsPage